import { Plane, Hotel, Calendar, MapPin, Clock, Ticket, ListCheck } from 'lucide-react';

export default function OverviewView({ itinerary, pageTheme }) {

  const {
      packageTrendsPageBackground,
      packageTrendsPageCardBackground,
      packageTrendsPagePrimaryColor,
      packageTrendsPageSecondColor,
      packageTrendsPageThirdColor,
      packageTrendsPageFourthColor,
  } = pageTheme;

  return (
    <div className="max-w-6xl mx-auto px-6 py-12">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
        {itinerary.products.map((product, index) => (
          <div
            key={product.product_type}
            className="space-y-6"
          >
            <div className="flex items-center gap-3 pb-4 border-b border-gray-100">
              <div className={`p-2 rounded-lg ${
                product.product_type === 'flight' ? 'bg-blue-50 text-blue-600' :
                product.product_type === 'hotel' ? 'bg-purple-50 text-purple-600' :
                `bg-[${(packageTrendsPagePrimaryColor+"1A")}] text-[${packageTrendsPagePrimaryColor}]`
              }`}>
                {
                product.product_type === 'flight' ? <Plane className="w-6 h-6" /> :
                product.product_type === 'hotel' ? <Hotel className="w-6 h-6" /> :
                product.product_type === 'event' ? <Calendar className="w-6 h-6" /> :
                <ListCheck className="w-6 h-6" />
              }
              </div>
              <h3 className="text-xl font-bold text-gray-900 -font-serif">{product.title}</h3>
            </div>

            <div className="space-y-4">
              {product.items.map((item, i) => (
                <div 
                  key={i}
                  className="group p-5 rounded-2xl bg-white border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300"
                >
                  <div className="flex justify-between items-start mb-4">
                    <p style={{color: packageTrendsPagePrimaryColor}} className="text-sm font-bold text-orange-500">
                      {new Date(item.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                    </p>
                    <div className="px-2 py-1 rounded bg-gray-50 text-[10px] font-bold uppercase tracking-widest text-gray-400">
                      Ref: {item.confirmation_number || 'N/A'}
                    </div>
                  </div>

                  <h4 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                    {item.name || item.topic || `${item.departure_airport} to ${item.arrival_airport}`}
                  </h4>

                  <div className="space-y-2">
                    {item.airline && (
                      <div className="flex items-center gap-2 text-sm text-gray-500">
                        <Plane className="w-4 h-4" />
                        <span>{item.airline}</span>
                      </div>
                    )}
                    {(item.departs || item.time || item.checkin_time) && (
                      <div className="flex items-center gap-2 text-sm text-gray-500">
                        <Clock className="w-4 h-4" />
                        <span>{item.departs || item.time || item.checkin_time}</span>
                      </div>
                    )}
                    {(item.venue || item.street || item.city) && (
                      <div className="flex items-center gap-2 text-sm text-gray-500">
                        <MapPin className="w-4 h-4" />
                        <span className="truncate">{item.venue || item.street || item.city}</span>
                      </div>
                    )}
                  </div>

                  {product.product_type === 'flight' && (
                    <div className="mt-4 pt-4 border-t border-gray-50 flex items-center justify-between text-xs font-medium text-gray-400">
                      <span>Gate: {item.gate}</span>
                      <span>Arrives: {item.arrives}</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
